import * as React from 'react';
import {CSSProperties} from "react";

interface Props {
	/**
	 * Column width for small devices. [1-12]
	 */
	sm?: number;
	/**
	 * Column width for medium devices. [1-12]
	 */
	md?: number;
	/**
	 * Column width for large devices. [1-12]
	 */
	lg?: number;
	/**
	 * Column width for extra large devices. [1-12]
	 */
	xl?: number;
	/**
	 * Custom style.
	 */
	style?: CSSProperties
}

export default class Col extends React.Component<Props, {}> {

	public static defaultProps: Partial<Props> = {
		sm: 12,
		md: 12,
		lg: 12,
		xl: 12,
	};

	render() {
		const classFromProps =
			`col-sm-${this.props.sm} col-md-${this.props.md} col-lg-${this.props.lg} col-xl-${this.props.xl}`;

		return (
			<div className={classFromProps} style={this.props.style}>
				{this.props.children}
			</div>
		);
	}
}